<template>
  <v-row no-gutters class="LeasePeriodsFilters pa-4 pa-sm-6">
    <v-col cols="12" class="d-sm-none mb-4">
      <RcFilterIcon class="mr-1" /> <span class="textSecondary--text font-weight-medium">Filters</span>
    </v-col>
    <v-col cols="6" md="auto" class="pl-md-0 mb-3 mb-md-0">
      <v-select
        v-model="leasePeriodFilters.semesterId"
        class="LeasePeriodsFilters__select"
        :style="{ width: '400px' }"
        placeholder="Move-in Semester"
        :items="semesters"
        clearable
        item-title="name"
        item-value="id"
        variant="outlined"
        hide-details
      />
    </v-col>
    <v-col cols="6" md="auto" class="pl-3 mb-3 mb-md-0">
      <v-select
        v-model="leasePeriodFilters.gender"
        class="LeasePeriodsFilters__select"
        placeholder="Gender"
        :items="genderOptions"
        item-title="text"
        item-value="value"
        clearable
        variant="outlined"
        hide-details
      />
    </v-col>
    <!--    <v-col cols="6" md="auto" class="pl-md-3">-->
    <!--      <v-select-->
    <!--        class="LeasePeriodsFilters__select"-->
    <!--        v-model="leasePeriodFilters.roomType"-->
    <!--        placeholder="Room Type"-->
    <!--        :items="roomTypeOptions"-->
    <!--        clearable-->
    <!--        outlined-->
    <!--        hide-details-->
    <!--      />-->
    <!--    </v-col>-->
    <v-col cols="6" md="auto" class="text-right flex-grow-1 pl-md-3 d-flex">
      <v-select
        v-model="leasePeriodFilters.sortBy"
        class="LeasePeriodsFilters__select"
        placeholder="Sort by"
        :items="dateSortOptions"
        item-title="text"
        item-value="value"
        clearable
        variant="outlined"
        hide-details
      />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { LeasePeriodFilters } from "./LeasePreiodTypes";
import { LeasePeriodSemester } from "../../../middleware/LeasePeriodSemester";
import RcFilterIcon from "./RcFilterIcon.vue";

@Component({
  name: "LeasePeriodsFilters",
  components: { RcFilterIcon },
})
export default class LeasePeriodsFilters extends Vue {
  @Prop({ required: true }) leasePeriodFilters: LeasePeriodFilters;
  @Prop({ required: true }) semesters: LeasePeriodSemester[];

  sem = [
    {
      end_date: "2024-12-31",
      icon: "W",
      id: 2,
      is_for_custom_lease: false,
      name: "Winter 24",
      start_date: "2024-09-05",
    },
  ];

  genderOptions = [
    { value: "M", text: "Male" },
    { value: "F", text: "Female" },
  ];

  roomTypeOptions = [
    { value: "shared", text: "Shared" },
    { value: "private", text: "Private" },
  ];

  dateSortOptions = [
    { value: "asc", text: "Ascending" },
    { value: "desc", text: "Descending" },
  ];
}
</script>

<style lang="scss">
.LeasePeriodsFilters {
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  &__select {
    width: 250px;
  }
}
</style>
